import React from 'react';
import { ReactComponent as ChevronLeftIcon } from '../../icons/chevron-left.svg';
import { ReactComponent as ChevronRightIcon } from '../../icons/chevron-right.svg';
import { ReactComponent as DoubleChevronLeftIcon } from '../../icons/doublechevron_left.svg';
import { ReactComponent as DoubleChevronRightIcon } from '../../icons/doublechevron_right.svg';
import styled from "styled-components";
import { colors } from "../../utils/colors";
import { purpleColors, slateColors } from '../ContentPages/AppLandingPage/styles';


const ArrowButton = styled('div')<{ disabled?: boolean }>`
  display: flex;
  width: 2.5rem;
  height: 2.5rem;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: 2px solid ${props => props.disabled ? slateColors[200] : slateColors[200]};
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  background-color: ${props => props.disabled ? slateColors[50] : slateColors[50]};
  transition: all 0.2s;

  svg {
    width: 1rem;
    height: 1rem;
    pointer-events: none;
  }

  svg path {
    fill: ${props => props.disabled ? slateColors[400] : slateColors[600]};
    transition: fill 0.2s;
  }

  &:hover {
    background-color: ${props => props.disabled ? slateColors[50] : slateColors[100]};
    border-color: ${props => props.disabled ? slateColors[200] : purpleColors[300]};

    svg path {
      fill: ${props => props.disabled ? slateColors[400] : slateColors[900]};
    }
  }

  &:active {
    background-color: ${props => props.disabled ? slateColors[50] : slateColors[200]};
    border-color: ${props => props.disabled ? slateColors[200] : purpleColors[400]};
    
    svg path {
      fill: ${props => props.disabled ? slateColors[400] : slateColors[900]};
    }
  }

  &:focus {
    outline: none;
    box-shadow: ${props => props.disabled ? 'none' : `0 0 0 3px ${purpleColors[100]}`};
  }
`;

type Props = {
  onClick: () => void;
  disabled: boolean;
} 

export const PrevButton: React.FC<Props> = ({ onClick, disabled }) => {
  return (
    <ArrowButton onClick={disabled ? undefined : onClick} disabled={disabled}>
      <ChevronLeftIcon width={14} height={14}/>
    </ArrowButton>
  );
}


export const NextButton: React.FC<Props> = ({ onClick, disabled }) => {
  return (
    <ArrowButton onClick={disabled ? undefined : onClick} disabled={disabled}>
      <ChevronRightIcon width={14} height={14}/>
    </ArrowButton>
  );
}

export const FirstButton: React.FC<Props> = ({ onClick, disabled }) => {
  return (
    <ArrowButton onClick={disabled ? undefined : onClick} disabled={disabled}>
      <DoubleChevronLeftIcon width={14} height={14}/>
    </ArrowButton>
  );
}


export const LastButton: React.FC<Props> = ({ onClick, disabled }) => {
  return (
    <ArrowButton onClick={disabled ? undefined : onClick} disabled={disabled}>
      <DoubleChevronRightIcon width={14} height={14}/>
    </ArrowButton>
  );
}

